import { useState } from "react";
import Select from "react-select";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { optionSelector } from "../../config/apiSPA";

const parameter = { id: null, question: "", key: "" };

function ModalNewSoalMatch({ show, onHide, submitClick, title, text, id }) {
  const [val, setVal] = useState(parameter);
  const [options, setOptions] = useState([]);

  function handleChange(mode, v) {
    switch (mode) {
      case "question":
        setVal({ ...val, question: v });
        break;
      case "kunci":
        setVal({ ...val, key: v });
        break;
    }
  }

  function handleSubmit(v) {
    submitClick(v);
  }

  function onShow() {
    setVal({ ...val, id: id });
    optionSelector(`/choice-matching-question1/${id}`).then((res) => setOptions(res));
  }
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          setVal(parameter);
          onHide();
        }}
        onShow={() => onShow()}
      >
        <ModalHeader closeButton>
          <h5 className="modal-title">{title ? title : "Blank Title"}</h5>
        </ModalHeader>
        <ModalBody>
          <div className="form-group mb-3">
            <label className="form-label">Question</label>
            <textarea onChange={(e) => handleChange("question", e.target.value)} className="form-control" />
            <label className="form-label">Key</label>
            <Select onChange={(e) => handleChange("kunci", e.value)} options={options} classNamePrefix="react-select" />
          </div>
          <div className="alert bg-inverse bg-opacity-15">{text ? text : "Blank text"}</div>
        </ModalBody>
        <ModalFooter>
          <button type="button" onClick={() => handleSubmit(val)} className={val.question !== "" && val.key !== "" ? "btn btn-outline-theme" : "btn btn-outline-theme disabled"}>
            Save changes
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalNewSoalMatch;
